// Tab «Просмотр» of a PC answer template (В9): the text with its variables marked, and the variables it may use.
import { useRecord } from '@confdeck/core-web';
import s from './conferences.module.css';

/** The same names `talk.review` fills (PC_TEMPLATE_VARS in src/pc.ts). */
const VARS: [string, string][] = [['talk.title', 'название доклада'], ['speaker.name', 'имя первого докладчика'], ['event.name', 'событие']];

export function PcTemplatePreview({ recordId }: { recordId: string }) {
  const rec = useRecord(recordId);
  if (!rec) return null;
  const text = String(rec.data.text ?? '');
  const parts = text.split(/(\{\{\s*[a-z_.]+\s*\}\})/gi);
  return (
    <section className={s.tplPreview}>
      <div className={s.tplText}>{parts.map((p, i) => (/^\{\{/.test(p) ? <mark key={i} className={s.tplVar}>{p}</mark> : <span key={i}>{p}</span>))}</div>
      <h3 className={s.tplHead}>Переменные</h3>
      <dl className={s.tplVars}>{VARS.map(([k, label]) => <div key={k}><dt><code>{`{{${k}}}`}</code></dt><dd>{label}</dd></div>)}</dl>
      <p className={s.tplHint}>Переменная без значения превращается в «—». Шаблон выбирают в «Комментарий и оценка» у доклада.</p>
    </section>
  );
}
